import { render, staticRenderFns } from "./Overlay.vue?vue&type=template&id=7d9ece50&scoped=true&"
import script from "./Overlay.vue?vue&type=script&lang=ts&"
export * from "./Overlay.vue?vue&type=script&lang=ts&"
import style0 from "./Overlay.vue?vue&type=style&index=0&id=7d9ece50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9ece50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d9ece50')) {
      api.createRecord('7d9ece50', component.options)
    } else {
      api.reload('7d9ece50', component.options)
    }
    module.hot.accept("./Overlay.vue?vue&type=template&id=7d9ece50&scoped=true&", function () {
      api.rerender('7d9ece50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Overlay.vue"
export default component.exports